import { render, staticRenderFns } from "./TaskViewCheckListDispatcher.vue?vue&type=template&id=82ef3972&scoped=true&lang=pug&"
import script from "./TaskViewCheckListDispatcher.vue?vue&type=script&lang=js&"
export * from "./TaskViewCheckListDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ef3972",
  null
  
)

export default component.exports